module.exports = __webpack_public_path__ + "img/courses-image003.c4715a31.jpg";